import React from 'react'

import { EMPTY_STATE, INSIGHT_MAX_AGE_DAYS } from './AgenticInsights.constants'

// TODO(backend): copy is first-pass and the case is a client-side heuristic
// (see getEmptyStateKind). Each case eventually needs a real runtime signal.
const CONTENT = {
  [EMPTY_STATE.NOTHING_ACTIONABLE]: {
    heading: 'No new insights this cycle.',
    body: "Balto analyzed this run's calls and didn't find a clear, actionable recommendation this time. The biggest drivers of lost conversions may be outside an agent's control, no single objection came up often enough to act on, or your agents are already handling the winnable ones well.",
    hint: 'Every conversion opportunity is broken down on the Explore tab.',
    when: 'Balto re-analyzes your calls regularly and will surface new insights when it finds them.',
  },
  [EMPTY_STATE.ALL_LAUNCHED]: {
    heading: "You've launched every insight we found.",
    body: "All of this run's insights are now running as experiments. Nice work.",
    hint: "Track how they're moving conversion on the Experiments tab.",
    when: 'Balto re-analyzes your calls regularly and will surface new insights when it finds them.',
  },
  [EMPTY_STATE.FIRST_RUN]: {
    heading: 'Your first analysis is on the way.',
    body: "Balto hasn't analyzed this run's calls yet. As soon as it does, your insights will appear here.",
    when: 'Your first analysis runs once enough calls have come in.',
  },
  [EMPTY_STATE.EXPIRED]: {
    heading: `No insights from the last ${INSIGHT_MAX_AGE_DAYS} days.`,
    body: `Balto's most recent analysis of these calls is more than ${INSIGHT_MAX_AGE_DAYS} days old, so its insights are no longer shown. New insights will appear here after the next analysis.`,
    hint: 'Experiments launched from earlier analyses are still on the Experiments tab.',
  },
  [EMPTY_STATE.ALL_DISMISSED]: {
    heading: 'No insights left to act on from this run.',
    body: 'Its remaining insights were dismissed. Dismissed insights are hidden for everyone in your organization, not deleted.',
    when: 'Balto re-analyzes your calls regularly and will surface new insights when it finds them.',
  },
  [EMPTY_STATE.LOW_VOLUME]: {
    heading: 'Not enough calls to analyze yet.',
    body: "This run doesn't have enough completed calls for Balto to find reliable patterns. Once volume picks up, insights will show up here.",
    hint: 'Browse what we do have on the Explore tab.',
  },
}

export const EmptyState = ({ kind }) => {
  const content = CONTENT[kind] || CONTENT[EMPTY_STATE.NOTHING_ACTIONABLE]

  return (
    <div className="agentic-empty-state">
      <h2 className="agentic-empty-state__heading">{content.heading}</h2>
      <p className="agentic-empty-state__body">{content.body}</p>
      {content.hint && <p className="agentic-empty-state__hint">{content.hint}</p>}
      {content.when && <p className="agentic-empty-state__when">{content.when}</p>}
    </div>
  )
}
